export default "__VITE_ASSET__CyYGuyZ4__"